<template>
  <div id="SzafaDruk">

    <div style="width: 100%;height: 40px;">
      <h5 style="width: 320px; text-align: center; display: inline-block;">
        {{$t('message.widok')}}: {{$t('message.przod')}}</h5>
      <h5 style="width: 270px;text-align: center;display: inline-block;">
        {{$t('message.widok')}}: {{$t('message.tyl')}}</h5>
    </div>

    <div id="szafa" v-if="wielkoscSzafy>0" :style="[BgImageTop('szafa/szafa_' + wielkoscSzafy + '.jpg'), {height: Number(wysokoscSzafy[0]) + 'px', 'margin-top': Number(wysokoscSzafy[1]) + 'px'}]"
    style="margin-right: 20px;margin-bottom: 25px;background-size: cover;">
      <div class="otwory_montazowe">
        <span v-for="(pole, index) in Number(wielkoscSzafy)" :key="index" :data-id="Number(wielkoscSzafy) - index"
        :style="{top: (index * (pxU)) + 'px'}">
          {{wielkoscSzafy - (index)}}
        </span>
      </div>
      <div
        class="area-items"
        group="druk"
        :list="outputs.items_przod"
        :disabled="true"
        :style="[{height: (pxU * wielkoscSzafy) + 'px'}]"
        style="position: relative !important;top: 28px;left: 15px;width: 253px;">
        <div class="list-group-item" v-for="(elPrzod, idPrzod) in outputs.items_przod" :key="idPrzod"
          :style="[{height: (Number(elPrzod.u) * Number(pxU)) + 'px', top: (Number(elPrzod.mount) * Number(pxU)) - pxU + 'px'}, BgImageTop('front/' + ((elPrzod.symbol && !elPrzod.personal) ? elPrzod.symbol.replace('/', ',') :
          ((elPrzod.symbol && elPrzod.personal) ? 'WPK000' : '')
          ) + '.png')]"
          style="background-size: contain;position: absolute;width: 246px; left:14px;">
          <span class="productCode">{{elPrzod.symbol}}</span>
        </div>
      </div>
    </div>

    <div id="szafa" v-if="wielkoscSzafy>0" :style="[BgImageTop('szafa/szafa_' + wielkoscSzafy + '.jpg'), {height: Number(wysokoscSzafy[0]) + 'px', 'margin-top': Number(wysokoscSzafy[1]) + 'px'}]"
    style="margin-right: 20px;margin-bottom: 25px;background-size: cover;">
      <div class="otwory_montazowe">
        <span v-for="(pole, index) in Number(wielkoscSzafy)" :key="index" :data-id="Number(wielkoscSzafy) - index"
        :style="{top: (index * (pxU)) + 'px'}">
          {{wielkoscSzafy - (index)}}
        </span>
      </div>
      <div
        class="area-items"
        group="druk"
        :list="outputs.items_tyl"
        :disabled="true"
        :style="[{height: (pxU * wielkoscSzafy) + 'px'}]"
        style="position: relative !important;top: 28px;left: 15px;width: 253px;">
        <div class="list-group-item" v-for="(elTyl, idTyl) in outputs.items_tyl" :key="idTyl"
          :style="[{height: (Number(elTyl.u) * Number(pxU)) + 'px', top: (Number(elTyl.mount) * Number(pxU)) - pxU + 'px'}, BgImageTop('front/' + ((elTyl.symbol && !elTyl.personal) ? elTyl.symbol.replace('/', ',') :
          ((elTyl.symbol && elTyl.personal) ? 'WPK000' : '')
          ) + '.png')]"
          style="background-size: contain;position: absolute;width: 246px; left:14px;">
          <span class="productCode">{{elTyl.symbol}}</span>
        </div>
      </div>
    </div>

    <div id="szafa" class="inne" :style="{height: (pxU * wielkoscSzafy) + 'px'}">
      <div class="list-group-item-inne" v-for="(elInne, idInne) in outputs.items_inne" :key="idInne">
        <span>
          <img style="height: 35px;" :src="getImgUrl(elInne.symbol)">
        </span>
        <span>{{elInne.value}}x {{elInne.symbol}}</span>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
// import rawDisplayer from './infra/rawDisplayer'
import { app } from '../../mixins/app'

export default {
  name: 'SzafaDruk',
  mixins: [app],
  display: 'Custom Clone',
  order: 3,
  components: {
    draggable
    // , rawDisplayer
  },
  data () {
    return {
      view: 'przod',
      pxU: 18,
      showPodzespoly: false,
      deviceSymbol: '',
      deviceNumber: '',
      zajeteMiejscePrzod: 0,
      wolneMiejscePrzod: 0,
      zajeteMiejsceTyl: 0,
      wolneMiejsceTyl: 0,
      indexPrzod: 0,
      indexTyl: 0,
      indexInne: 0,
      indexGlobal: 0,
      inputInne: {},
      szafaPrzod: [
      ],
      szafaTyl: [
      ],
      szafaInne: [
      ]
    }
  },
  computed: {
    ...mapGetters('app', ['outputs']),
    wielkoscSzafy () {
      return this.$options.filters.decimal(this.outputs.szafa.wysokosc_montazowa)
    },
    wysokoscSzafy () {
      if (this.wielkoscSzafy === 4) {
        return [130, 0]
      } else if (this.wielkoscSzafy === 6) {
        return [166, 0]
      } else if (this.wielkoscSzafy === 9) {
        return [220, 0]
      } else if (this.wielkoscSzafy === 12) {
        return [274, 0]
      } else if (this.wielkoscSzafy === 15) {
        return [328, 0]
      } else if (this.wielkoscSzafy === 18) {
        return [382, 0]
      } else if (this.wielkoscSzafy === 22) {
        return [454, 0]
      } else if (this.wielkoscSzafy === 27) {
        return [544, 0]
      } else if (this.wielkoscSzafy === 42) {
        return [814, 0]
      }
    }
  }
}
</script>

<style scoped>
#SzafaDruk {
width: 100%;
display: block;
margin-top: 15px;
}
#szafa {
  width:305px;
  padding: 0px;
  margin-left: 5px;
  float: left;
  /* transform: scale(.8); */
  background-repeat: no-repeat;
}
.inne {
  width: 120px !important;
  margin-left: 10px;
}
.otwory_montazowe {
  width:10px;
  margin-bottom:0px;
  text-align: left;
  position: relative;
  top:28px;
  left: 18px;
  /* transform: scale(0.75); */
}
.otwory_montazowe span{
font-size: 8px;
position: absolute;
margin-left: -14px;
}
div.list-group-item {
  line-height: 2px; cursor: pointer;
  padding:0px;
  margin-bottom:0px;
  background-color: #fff;
  border-bottom: 1px solid #959595
}
div.list-group-item:hover {
  background: #eee
}
.list-group-item-inne {
background: none;
padding: 4px;
border: 1px solid #ccc;
width: 115px;
}
.list-group-item-inne input {
background: #f4f4f4;
padding: 6px;
width: 70px;
}
.list-group-item-inne span {
width: 100%;
display: inline-block;
text-align: center;
}
#urzadzenia {
  width:250px; margin-right: 20px;
}
div.list-group {
  height: 756px;
  width: 250px;
  position: relative;
  /* top: 22px; */
  top: 25px;
  left: 15px;
}

.productCode {
  font-size: 10px;
  color: white;
  position: absolute;
  top: 4px;
  left: 42%;
}
</style>



// WEBPACK FOOTER //
// src/components/View/SzafaDruk.vue